import {
  GetOrderQuery,
  type IGetOrderQueryResponse,
} from '@fhs-legacy/frontend/src/remote/queries/order';
import { client as legacyClient } from '@fhs-legacy/frontend/src/state/graphql/client';

import { ORDER_SUBMITTED_STATUSES } from '../order-status';

export async function recoverSubmittedOrder(rbiOrderId: string) {
  const response = await legacyClient.query<IGetOrderQueryResponse>({
    query: GetOrderQuery,
    variables: { rbiOrderId },
    fetchPolicy: 'network-only',
  });

  const recoveredOrder = response.data?.order;
  if (!recoveredOrder?.status || !ORDER_SUBMITTED_STATUSES.has(recoveredOrder.status)) {
    return null;
  }

  return recoveredOrder;
}
